import { isProduction } from './environment'

export const BBQ_PZALA_VENDOR_ID = isProduction ? 78 : 173
export const GON_GANG_VENDOR_ID = isProduction ? 4 : 140
export enum CouponAndRedeemTabKey {
  COUPON = 'COUPON',
  REDEEM = 'REDEEM',
}

const ExternalURL = isProduction
  ? 'https://linebcapi.foodpassion.co.th:8443'
  : 'https://linebcdev.foodpassion.co.th:8443'

export const FoodpassionExternalPage = {
  PROFILE: `${ExternalURL}/profile`,
  BENEFITS: `${ExternalURL}/benefits`,
  CONSENT: `${ExternalURL}/consent`,
}
